import type { DropdownProps } from "@/components/mosaic/ui/TileTitle/TileTitle";
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@/components/ui/select";
import { fiscalPeriodsGrouped } from "../../../config";
import type { FiscalPeriod } from "../../../types";

export const FinancialsDropdown: React.FC<DropdownProps> = ({
	state,
	onStateChange,
}) => {
	const fiscalPeriod = (state?.fiscalPeriod as FiscalPeriod) ?? "QTR";

	return (
		<Select
			value={fiscalPeriod}
			onValueChange={(value: FiscalPeriod) =>
				onStateChange({ fiscalPeriod: value })
			}
		>
			<SelectTrigger className="w-fit px-2 ml-3 text-gold font-bold text-sm">
				<SelectValue data-testid="fiscalPeriod">{fiscalPeriod}</SelectValue>
			</SelectTrigger>

			<SelectContent align="start">
				{Object.keys(fiscalPeriodsGrouped).map((period) => (
					<SelectItem key={period} value={period}>
						<SelectValue data-testid="fiscalPeriodOption">{period}</SelectValue>
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	);
};

export default FinancialsDropdown;
